const NAIRA_SIGN = "₦";
const K_ABBREVIATION_THRESHOLD = 100_000;

export const formatNairaAbbreviated = (amount: number): string => {
  return abbreviate(amount, K_ABBREVIATION_THRESHOLD);
};

/**
 * Tighter abbreviation for chart axis ticks — abbreviates from ₦1K up so
 * ticks stay terse and stay visually consistent on the same axis
 * (avoiding mixes like "₦50,000" next to "₦100K").
 */
export const formatNairaAxis = (amount: number): string => {
  return abbreviate(amount, 1_000);
};

const abbreviate = (amount: number, kThreshold: number): string => {
  if (amount === 0) return `${NAIRA_SIGN}0`;
  const sign = amount < 0 ? "-" : "";
  const absolute = Math.abs(amount);

  if (absolute >= 1_000_000_000) {
    return `${sign}${NAIRA_SIGN}${formatToThreeSigFigs(absolute / 1_000_000_000)}B`;
  }
  if (absolute >= 1_000_000) {
    return `${sign}${NAIRA_SIGN}${formatToThreeSigFigs(absolute / 1_000_000)}M`;
  }
  if (absolute >= kThreshold) {
    return `${sign}${NAIRA_SIGN}${formatToThreeSigFigs(absolute / 1_000)}K`;
  }

  return `${sign}${NAIRA_SIGN}${absolute.toLocaleString("en-NG", {
    maximumFractionDigits: 0,
  })}`;
};

const formatToThreeSigFigs = (value: number): string => {
  let fixed: string;
  if (value >= 100) fixed = value.toFixed(0);
  else if (value >= 10) fixed = value.toFixed(1);
  else fixed = value.toFixed(2);

  // Only strip trailing zeros when there's a decimal point — otherwise "450" loses its "0".
  return fixed.includes(".") ? fixed.replace(/\.?0+$/, "") : fixed;
};
